import { createTranslations } from '../../i18n/types';
import { wikiItem as fa } from './translations/fa';
import { wikiItem as uk } from './translations/uk';
import { wikiItem as de } from './translations/de';
import { wikiItem as es } from './translations/es';
import { wikiItem as pl } from './translations/pl';

const en = {
  typeSticker: 'Sticker',
  typeAgent: 'Agent',
  typeCharm: 'Charm',
  typeMusicKit: 'Music kit',
  typePatch: 'Patch',
  typeGraffiti: 'Graffiti',
  typePin: 'Pin',
  sectionStickers: 'Stickers',
  sectionAgents: 'Agents',
  sectionCharms: 'Charms',
  sectionMusicKits: 'Music kits',
  sectionPatches: 'Patches',
  sectionGraffiti: 'Graffiti',
  sectionPins: 'Pins',
  kindCase: 'Case',
  kindStickerCapsule: 'Sticker capsule',
  kindAutographCapsule: 'Autograph capsule',
  kindSouvenirPackage: 'Souvenir package',
  kindMusicKitBox: 'Music kit box',
  kindPatchCapsule: 'Patch pack',
  kindPinsCapsule: 'Pin capsule',
  kindGraffitiBox: 'Graffiti box',
  tabAll: 'All',
  tabCases: 'Cases',
  tabStickerCapsules: 'Sticker capsules',
  tabAutographCapsules: 'Autograph capsules',
  tabSouvenirPackages: 'Souvenir packages',
  tabMusicKitBoxes: 'Music kit boxes',
  tabPatchCapsules: 'Patch packs',
  tabPinsCapsules: 'Pin capsules',
  tabGraffitiBoxes: 'Graffiti boxes',
  kindsNavLabel: 'Container types',
  containersH1: 'CS2 cases and capsules',
  h1StickerCapsules: 'CS2 sticker capsules',
  h1AutographCapsules: 'CS2 autograph capsules',
  h1SouvenirPackages: 'CS2 souvenir packages',
  h1MusicKitBoxes: 'CS2 music kit boxes',
  h1PatchCapsules: 'CS2 patch packs',
  h1PinsCapsules: 'CS2 pin capsules',
  h1GraffitiBoxes: 'CS2 graffiti boxes',
  stickersOne: '{{count}} sticker',
  stickersFew: '{{count}} stickers',
  stickersMany: '{{count}} stickers',
  musicKitsOne: '{{count}} music kit',
  musicKitsFew: '{{count}} music kits',
  musicKitsMany: '{{count}} music kits',
  patchesOne: '{{count}} patch',
  patchesFew: '{{count}} patches',
  patchesMany: '{{count}} patches',
  pinsOne: '{{count}} pin',
  pinsFew: '{{count}} pins',
  pinsMany: '{{count}} pins',
  graffitiOne: '{{count}} graffiti',
  graffitiFew: '{{count}} graffiti',
  graffitiMany: '{{count}} graffiti',
  colorsOne: '{{count}} color',
  colorsFew: '{{count}} colors',
  colorsMany: '{{count}} colors',
  inGameSince: 'In the game since {{year}}',
  contentsTitle: 'What’s inside',
  variantsTitle: 'Variants',
  groupSticker: 'Sticker',
  groupSlab: 'In a slab',
  effectPaper: 'Paper',
  effectHolo: 'Holo',
  effectFoil: 'Foil',
  effectGold: 'Gold',
  effectGlitter: 'Glitter',
  effectLenticular: 'Lenticular',
  effectEmbroidered: 'Embroidered',
  stickerAutograph: 'Autograph',
  stickerTeam: 'Team',
  stickerEvent: 'Tournament',
  stickerOther: 'Other',
  sideT: 'Terrorists',
  sideCt: 'Counter-Terrorists',
  statType: 'Type',
  statStickerKind: 'Sticker type',
  statTournament: 'Tournament',
  statTeam: 'Team',
  statPlayer: 'Player',
  statEffects: 'Effects',
  statSlab: 'In a slab',
  statSide: 'Side',
  statArtist: 'Artist',
  statStatTrak: 'StatTrak™',
  statColors: 'Colors',
  valueYes: 'Available',
  valueNo: 'Not available',
  whereTitle: 'Where to get it',
  whereCollection: 'Collection',
  whereStickerPack: 'Sticker pack',
  shotHintItem: 'This item drops from these SHOT cases.',
  souvenirPackagesRow: 'Souvenir packages',
  moreCount: '{{count}} more',
  typeHighlight: 'Highlight charm',
  typePass: 'Pass',
  typeKey: 'Key',
  sectionHighlights: 'Highlight charms',
  sectionPasses: 'Passes',
  sectionKeys: 'Keys',
  kindOther: 'Package',
  tabOther: 'Other',
  h1Other: 'Other CS2 packages',
  itemsOne: '{{count}} item',
  itemsFew: '{{count}} items',
  itemsMany: '{{count}} items',
  statEvent: 'Tournament',
  statStage: 'Stage',
  statMap: 'Map',
  statTeams: 'Match',
  statVideo: 'Video',
  watchVideo: 'Watch the moment',
  statOpens: 'Opens',
  listH1Stickers: 'CS2 stickers',
  listH1Agents: 'CS2 agents',
  listH1Charms: 'CS2 charms',
  listH1MusicKits: 'CS2 music kits',
  listH1Patches: 'CS2 patches',
  listH1Graffiti: 'CS2 graffiti',
  listH1Highlights: 'CS2 highlight charms',
  listH1Pins: 'CS2 pins',
  listH1Passes: 'CS2 passes',
  listH1Keys: 'CS2 case keys',
  listCount: '{{count}} in the game',
  typeCollectible: 'Collectible',
  sectionCollectibles: 'Coins, medals and trophies',
  listH1Collectibles: 'CS2 coins, medals and trophies',
  collectibleCoin: 'Coin',
  collectibleTrophy: 'Trophy',
  collectibleMedal: 'Medal',
  versionNumber: 'Version {{n}}',
  allItemsTitle: 'All items',
  sectionContainers: 'Cases and capsules',
};

export default createTranslations({
  en,
  ru: {
    typeSticker: 'Наклейка',
    typeAgent: 'Агент',
    typeCharm: 'Брелок',
    typeMusicKit: 'Набор музыки',
    typePatch: 'Нашивка',
    typeGraffiti: 'Граффити',
    typePin: 'Значок',
    sectionStickers: 'Наклейки',
    sectionAgents: 'Агенты',
    sectionCharms: 'Брелоки',
    sectionMusicKits: 'Наборы музыки',
    sectionPatches: 'Нашивки',
    sectionGraffiti: 'Граффити',
    sectionPins: 'Значки',
    kindCase: 'Кейс',
    kindStickerCapsule: 'Капсула с наклейками',
    kindAutographCapsule: 'Капсула с автографами',
    kindSouvenirPackage: 'Сувенирный набор',
    kindMusicKitBox: 'Коробка с наборами музыки',
    kindPatchCapsule: 'Набор нашивок',
    kindPinsCapsule: 'Капсула со значками',
    kindGraffitiBox: 'Коробка с граффити',
    tabAll: 'Все',
    tabCases: 'Кейсы',
    tabStickerCapsules: 'Капсулы с наклейками',
    tabAutographCapsules: 'Капсулы с автографами',
    tabSouvenirPackages: 'Сувенирные наборы',
    tabMusicKitBoxes: 'Коробки с музыкой',
    tabPatchCapsules: 'Наборы нашивок',
    tabPinsCapsules: 'Капсулы со значками',
    tabGraffitiBoxes: 'Коробки с граффити',
    kindsNavLabel: 'Виды кейсов и капсул',
    containersH1: 'Кейсы и капсулы CS2',
    h1StickerCapsules: 'Капсулы с наклейками CS2',
    h1AutographCapsules: 'Капсулы с автографами CS2',
    h1SouvenirPackages: 'Сувенирные наборы CS2',
    h1MusicKitBoxes: 'Коробки с наборами музыки CS2',
    h1PatchCapsules: 'Наборы нашивок CS2',
    h1PinsCapsules: 'Капсулы со значками CS2',
    h1GraffitiBoxes: 'Коробки с граффити CS2',
    stickersOne: '{{count}} наклейка',
    stickersFew: '{{count}} наклейки',
    stickersMany: '{{count}} наклеек',
    musicKitsOne: '{{count}} набор музыки',
    musicKitsFew: '{{count}} набора музыки',
    musicKitsMany: '{{count}} наборов музыки',
    patchesOne: '{{count}} нашивка',
    patchesFew: '{{count}} нашивки',
    patchesMany: '{{count}} нашивок',
    pinsOne: '{{count}} значок',
    pinsFew: '{{count}} значка',
    pinsMany: '{{count}} значков',
    graffitiOne: '{{count}} граффити',
    graffitiFew: '{{count}} граффити',
    graffitiMany: '{{count}} граффити',
    colorsOne: '{{count}} цвет',
    colorsFew: '{{count}} цвета',
    colorsMany: '{{count}} цветов',
    inGameSince: 'В игре с {{year}} года',
    contentsTitle: 'Что внутри',
    variantsTitle: 'Варианты',
    groupSticker: 'Наклейка',
    groupSlab: 'В слэбе',
    effectPaper: 'Бумажная',
    effectHolo: 'Голографическая',
    effectFoil: 'Металлическая',
    effectGold: 'Золотая',
    effectGlitter: 'Блестящая',
    effectLenticular: 'Лентикулярная',
    effectEmbroidered: 'Вышитая',
    stickerAutograph: 'Автограф',
    stickerTeam: 'Команда',
    stickerEvent: 'Турнир',
    stickerOther: 'Другое',
    sideT: 'Террористы',
    sideCt: 'Спецназ',
    statType: 'Тип',
    statStickerKind: 'Вид наклейки',
    statTournament: 'Турнир',
    statTeam: 'Команда',
    statPlayer: 'Игрок',
    statEffects: 'Эффекты',
    statSlab: 'В слэбе',
    statSide: 'Сторона',
    statArtist: 'Автор музыки',
    statStatTrak: 'StatTrak™',
    statColors: 'Цвета',
    valueYes: 'Есть',
    valueNo: 'Нет',
    whereTitle: 'Где найти',
    whereCollection: 'Коллекция',
    whereStickerPack: 'Набор наклеек',
    shotHintItem: 'Этот предмет выпадает из этих кейсов SHOT.',
    souvenirPackagesRow: 'Сувенирные наборы',
    moreCount: 'Ещё {{count}}',
    typeHighlight: 'Брелок с ярким моментом',
    typePass: 'Пропуск',
    typeKey: 'Ключ',
    sectionHighlights: 'Брелоки с яркими моментами',
    sectionPasses: 'Пропуски',
    sectionKeys: 'Ключи',
    kindOther: 'Набор',
    tabOther: 'Другое',
    h1Other: 'Другие наборы CS2',
    itemsOne: '{{count}} предмет',
    itemsFew: '{{count}} предмета',
    itemsMany: '{{count}} предметов',
    statEvent: 'Турнир',
    statStage: 'Стадия',
    statMap: 'Карта',
    statTeams: 'Матч',
    statVideo: 'Видео',
    watchVideo: 'Смотреть момент',
    statOpens: 'Открывает',
    listH1Stickers: 'Наклейки CS2',
    listH1Agents: 'Агенты CS2',
    listH1Charms: 'Брелоки CS2',
    listH1MusicKits: 'Наборы музыки CS2',
    listH1Patches: 'Нашивки CS2',
    listH1Graffiti: 'Граффити CS2',
    listH1Highlights: 'Брелоки с яркими моментами CS2',
    listH1Pins: 'Значки CS2',
    listH1Passes: 'Пропуски CS2',
    listH1Keys: 'Ключи от кейсов CS2',
    listCount: 'В игре: {{count}}',
    typeCollectible: 'Награда',
    sectionCollectibles: 'Монеты, медали и трофеи',
    listH1Collectibles: 'Монеты, медали и трофеи CS2',
    collectibleCoin: 'Монета',
    collectibleTrophy: 'Трофей',
    collectibleMedal: 'Медаль',
    versionNumber: 'Версия {{n}}',
    allItemsTitle: 'Все предметы',
    sectionContainers: 'Кейсы и капсулы',
  },
  uz: {
    typeSticker: 'Stiker',
    typeAgent: 'Agent',
    typeCharm: 'Charm',
    typeMusicKit: 'Musiqa toʻplami',
    typePatch: 'Yamoq',
    typeGraffiti: 'Graffiti',
    typePin: 'Nishon',
    sectionStickers: 'Stikerlar',
    sectionAgents: 'Agentlar',
    sectionCharms: 'Charmlar',
    sectionMusicKits: 'Musiqa toʻplamlari',
    sectionPatches: 'Yamoqlar',
    sectionGraffiti: 'Graffitilar',
    sectionPins: 'Nishonlar',
    kindCase: 'Keys',
    kindStickerCapsule: 'Stikerlar kapsulasi',
    kindAutographCapsule: 'Avtograflar kapsulasi',
    kindSouvenirPackage: 'Suvenir paketi',
    kindMusicKitBox: 'Musiqa toʻplamlari qutisi',
    kindPatchCapsule: 'Yamoqlar toʻplami',
    kindPinsCapsule: 'Nishonlar kapsulasi',
    kindGraffitiBox: 'Graffiti qutisi',
    tabAll: 'Hammasi',
    tabCases: 'Keyslar',
    tabStickerCapsules: 'Stikerlar kapsulalari',
    tabAutographCapsules: 'Avtograflar kapsulalari',
    tabSouvenirPackages: 'Suvenir paketlari',
    tabMusicKitBoxes: 'Musiqa qutilari',
    tabPatchCapsules: 'Yamoqlar toʻplamlari',
    tabPinsCapsules: 'Nishonlar kapsulalari',
    tabGraffitiBoxes: 'Graffiti qutilari',
    kindsNavLabel: 'Keys va kapsula turlari',
    containersH1: 'CS2 keyslari va kapsulalari',
    h1StickerCapsules: 'CS2 stikerlar kapsulalari',
    h1AutographCapsules: 'CS2 avtograflar kapsulalari',
    h1SouvenirPackages: 'CS2 suvenir paketlari',
    h1MusicKitBoxes: 'CS2 musiqa toʻplamlari qutilari',
    h1PatchCapsules: 'CS2 yamoqlar toʻplamlari',
    h1PinsCapsules: 'CS2 nishonlar kapsulalari',
    h1GraffitiBoxes: 'CS2 graffiti qutilari',
    stickersOne: '{{count}} ta stiker',
    stickersFew: '{{count}} ta stiker',
    stickersMany: '{{count}} ta stiker',
    musicKitsOne: '{{count}} ta musiqa toʻplami',
    musicKitsFew: '{{count}} ta musiqa toʻplami',
    musicKitsMany: '{{count}} ta musiqa toʻplami',
    patchesOne: '{{count}} ta yamoq',
    patchesFew: '{{count}} ta yamoq',
    patchesMany: '{{count}} ta yamoq',
    pinsOne: '{{count}} ta nishon',
    pinsFew: '{{count}} ta nishon',
    pinsMany: '{{count}} ta nishon',
    graffitiOne: '{{count}} ta graffiti',
    graffitiFew: '{{count}} ta graffiti',
    graffitiMany: '{{count}} ta graffiti',
    colorsOne: '{{count}} ta rang',
    colorsFew: '{{count}} ta rang',
    colorsMany: '{{count}} ta rang',
    inGameSince: '{{year}}-yildan beri oʻyinda',
    contentsTitle: 'Ichidan nima tushadi',
    variantsTitle: 'Variantlar',
    groupSticker: 'Stiker',
    groupSlab: 'Slab ichida',
    effectPaper: 'Qogʻoz',
    effectHolo: 'Golografik',
    effectFoil: 'Folga',
    effectGold: 'Oltin',
    effectGlitter: 'Yaltiroq',
    effectLenticular: 'Lentikulyar',
    effectEmbroidered: 'Kashtali',
    stickerAutograph: 'Avtograf',
    stickerTeam: 'Jamoa',
    stickerEvent: 'Turnir',
    stickerOther: 'Boshqa',
    sideT: 'Terrorchilar',
    sideCt: 'Maxsus kuchlar',
    statType: 'Turi',
    statStickerKind: 'Stiker turi',
    statTournament: 'Turnir',
    statTeam: 'Jamoa',
    statPlayer: 'Oʻyinchi',
    statEffects: 'Effektlar',
    statSlab: 'Slab ichida',
    statSide: 'Tomon',
    statArtist: 'Muallif',
    statStatTrak: 'StatTrak™',
    statColors: 'Ranglar',
    valueYes: 'Bor',
    valueNo: 'Yoʻq',
    whereTitle: 'Qayerdan olish mumkin',
    whereCollection: 'Kolleksiya',
    whereStickerPack: 'Stikerlar toʻplami',
    shotHintItem: 'Bu buyum quyidagi SHOT keyslaridan tushadi.',
    souvenirPackagesRow: 'Suvenir paketlari',
    moreCount: 'Yana {{count}} ta',
    typeHighlight: 'Yorqin lahza charmi',
    typePass: 'Ruxsatnoma',
    typeKey: 'Kalit',
    sectionHighlights: 'Yorqin lahza charmlari',
    sectionPasses: 'Ruxsatnomalar',
    sectionKeys: 'Kalitlar',
    kindOther: 'Toʻplam',
    tabOther: 'Boshqa',
    h1Other: 'CS2ning boshqa toʻplamlari',
    itemsOne: '{{count}} ta buyum',
    itemsFew: '{{count}} ta buyum',
    itemsMany: '{{count}} ta buyum',
    statEvent: 'Turnir',
    statStage: 'Bosqich',
    statMap: 'Xarita',
    statTeams: 'Oʻyin',
    statVideo: 'Video',
    watchVideo: 'Lahzani koʻrish',
    statOpens: 'Ochadi',
    listH1Stickers: 'CS2 stikerlari',
    listH1Agents: 'CS2 agentlari',
    listH1Charms: 'CS2 charmlari',
    listH1MusicKits: 'CS2 musiqa toʻplamlari',
    listH1Patches: 'CS2 yamoqlari',
    listH1Graffiti: 'CS2 graffitilari',
    listH1Highlights: 'CS2 yorqin lahza charmlari',
    listH1Pins: 'CS2 nishonlari',
    listH1Passes: 'CS2 ruxsatnomalari',
    listH1Keys: 'CS2 keys kalitlari',
    listCount: 'Oʻyinda: {{count}} ta',
    typeCollectible: 'Mukofot',
    sectionCollectibles: 'Tangalar, medallar va kuboklar',
    listH1Collectibles: 'CS2 tangalari, medallari va kuboklari',
    collectibleCoin: 'Tanga',
    collectibleTrophy: 'Kubok',
    collectibleMedal: 'Medal',
    versionNumber: '{{n}}-versiya',
    allItemsTitle: 'Barcha buyumlar',
    sectionContainers: 'Keyslar va kapsulalar',
  },
  // WHY: вики на фарси не открывается (/fa/wiki → 404), блок нужен только ради типа словаря
  fa,
  uk,
  de,
  es,
  pl,
  pt: {
    typeSticker: 'Adesivo',
    typeAgent: 'Agente',
    typeCharm: 'Chaveiro',
    typeMusicKit: 'Kit de música',
    typePatch: 'Emblema',
    typeGraffiti: 'Grafite',
    typePin: 'Broche',
    sectionStickers: 'Adesivos',
    sectionAgents: 'Agentes',
    sectionCharms: 'Chaveiros',
    sectionMusicKits: 'Kits de música',
    sectionPatches: 'Emblemas',
    sectionGraffiti: 'Grafites',
    sectionPins: 'Broches',
    kindCase: 'Caixa',
    kindStickerCapsule: 'Cápsula de adesivos',
    kindAutographCapsule: 'Cápsula de autógrafos',
    kindSouvenirPackage: 'Pacote de lembrança',
    kindMusicKitBox: 'Caixa de kits de música',
    kindPatchCapsule: 'Pacote de emblemas',
    kindPinsCapsule: 'Cápsula de broches',
    kindGraffitiBox: 'Caixa de grafites',
    tabAll: 'Todos',
    tabCases: 'Caixas',
    tabStickerCapsules: 'Cápsulas de adesivos',
    tabAutographCapsules: 'Cápsulas de autógrafos',
    tabSouvenirPackages: 'Pacotes de lembrança',
    tabMusicKitBoxes: 'Caixas de música',
    tabPatchCapsules: 'Pacotes de emblemas',
    tabPinsCapsules: 'Cápsulas de broches',
    tabGraffitiBoxes: 'Caixas de grafites',
    kindsNavLabel: 'Tipos de caixas e cápsulas',
    containersH1: 'Caixas e cápsulas do CS2',
    h1StickerCapsules: 'Cápsulas de adesivos do CS2',
    h1AutographCapsules: 'Cápsulas de autógrafos do CS2',
    h1SouvenirPackages: 'Pacotes de lembrança do CS2',
    h1MusicKitBoxes: 'Caixas de kits de música do CS2',
    h1PatchCapsules: 'Pacotes de emblemas do CS2',
    h1PinsCapsules: 'Cápsulas de broches do CS2',
    h1GraffitiBoxes: 'Caixas de grafites do CS2',
    stickersOne: '{{count}} adesivo',
    stickersFew: '{{count}} adesivos',
    stickersMany: '{{count}} adesivos',
    musicKitsOne: '{{count}} kit de música',
    musicKitsFew: '{{count}} kits de música',
    musicKitsMany: '{{count}} kits de música',
    patchesOne: '{{count}} emblema',
    patchesFew: '{{count}} emblemas',
    patchesMany: '{{count}} emblemas',
    pinsOne: '{{count}} broche',
    pinsFew: '{{count}} broches',
    pinsMany: '{{count}} broches',
    graffitiOne: '{{count}} grafite',
    graffitiFew: '{{count}} grafites',
    graffitiMany: '{{count}} grafites',
    colorsOne: '{{count}} cor',
    colorsFew: '{{count}} cores',
    colorsMany: '{{count}} cores',
    inGameSince: 'No jogo desde {{year}}',
    contentsTitle: 'O que vem dentro',
    variantsTitle: 'Variantes',
    groupSticker: 'Adesivo',
    groupSlab: 'Em slab',
    effectPaper: 'Papel',
    effectHolo: 'Holográfico',
    effectFoil: 'Laminado',
    effectGold: 'Dourado',
    effectGlitter: 'Glitter',
    effectLenticular: 'Lenticular',
    effectEmbroidered: 'Bordado',
    stickerAutograph: 'Autógrafo',
    stickerTeam: 'Equipe',
    stickerEvent: 'Torneio',
    stickerOther: 'Outro',
    sideT: 'Terroristas',
    sideCt: 'Contra-Terroristas',
    statType: 'Tipo',
    statStickerKind: 'Tipo de adesivo',
    statTournament: 'Torneio',
    statTeam: 'Equipe',
    statPlayer: 'Jogador',
    statEffects: 'Efeitos',
    statSlab: 'Em slab',
    statSide: 'Lado',
    statArtist: 'Artista',
    statStatTrak: 'StatTrak™',
    statColors: 'Cores',
    valueYes: 'Sim',
    valueNo: 'Não',
    whereTitle: 'Onde conseguir',
    whereCollection: 'Coleção',
    whereStickerPack: 'Pacote de adesivos',
    shotHintItem: 'Este item sai destas caixas do SHOT.',
    souvenirPackagesRow: 'Pacotes de lembrança',
    moreCount: 'Mais {{count}}',
    typeHighlight: 'Chaveiro de destaque',
    typePass: 'Passe',
    typeKey: 'Chave',
    sectionHighlights: 'Chaveiros de destaque',
    sectionPasses: 'Passes',
    sectionKeys: 'Chaves',
    kindOther: 'Pacote',
    tabOther: 'Outros',
    h1Other: 'Outros pacotes do CS2',
    itemsOne: '{{count}} item',
    itemsFew: '{{count}} itens',
    itemsMany: '{{count}} itens',
    statEvent: 'Torneio',
    statStage: 'Fase',
    statMap: 'Mapa',
    statTeams: 'Partida',
    statVideo: 'Vídeo',
    watchVideo: 'Ver o lance',
    statOpens: 'Abre',
    listH1Stickers: 'Adesivos do CS2',
    listH1Agents: 'Agentes do CS2',
    listH1Charms: 'Chaveiros do CS2',
    listH1MusicKits: 'Kits de música do CS2',
    listH1Patches: 'Emblemas do CS2',
    listH1Graffiti: 'Grafites do CS2',
    listH1Highlights: 'Chaveiros de destaque do CS2',
    listH1Pins: 'Broches do CS2',
    listH1Passes: 'Passes do CS2',
    listH1Keys: 'Chaves de caixas do CS2',
    listCount: 'No jogo: {{count}}',
    typeCollectible: 'Colecionável',
    sectionCollectibles: 'Moedas, medalhas e troféus',
    listH1Collectibles: 'Moedas, medalhas e troféus do CS2',
    collectibleCoin: 'Moeda',
    collectibleTrophy: 'Troféu',
    collectibleMedal: 'Medalha',
    versionNumber: 'Versão {{n}}',
    allItemsTitle: 'Todos os itens',
    sectionContainers: 'Caixas e cápsulas',
  },
  tr: {
    typeSticker: 'Çıkartma',
    typeAgent: 'Ajan',
    typeCharm: 'Anahtarlık',
    typeMusicKit: 'Müzik kiti',
    typePatch: 'Yama',
    typeGraffiti: 'Grafiti',
    typePin: 'Rozet',
    sectionStickers: 'Çıkartmalar',
    sectionAgents: 'Ajanlar',
    sectionCharms: 'Anahtarlıklar',
    sectionMusicKits: 'Müzik kitleri',
    sectionPatches: 'Yamalar',
    sectionGraffiti: 'Grafitiler',
    sectionPins: 'Rozetler',
    kindCase: 'Kasa',
    kindStickerCapsule: 'Çıkartma kapsülü',
    kindAutographCapsule: 'İmza kapsülü',
    kindSouvenirPackage: 'Hatıra paketi',
    kindMusicKitBox: 'Müzik kiti kutusu',
    kindPatchCapsule: 'Yama paketi',
    kindPinsCapsule: 'Rozet kapsülü',
    kindGraffitiBox: 'Grafiti kutusu',
    tabAll: 'Tümü',
    tabCases: 'Kasalar',
    tabStickerCapsules: 'Çıkartma kapsülleri',
    tabAutographCapsules: 'İmza kapsülleri',
    tabSouvenirPackages: 'Hatıra paketleri',
    tabMusicKitBoxes: 'Müzik kutuları',
    tabPatchCapsules: 'Yama paketleri',
    tabPinsCapsules: 'Rozet kapsülleri',
    tabGraffitiBoxes: 'Grafiti kutuları',
    kindsNavLabel: 'Kasa ve kapsül türleri',
    containersH1: 'CS2 kasaları ve kapsülleri',
    h1StickerCapsules: 'CS2 çıkartma kapsülleri',
    h1AutographCapsules: 'CS2 imza kapsülleri',
    h1SouvenirPackages: 'CS2 hatıra paketleri',
    h1MusicKitBoxes: 'CS2 müzik kiti kutuları',
    h1PatchCapsules: 'CS2 yama paketleri',
    h1PinsCapsules: 'CS2 rozet kapsülleri',
    h1GraffitiBoxes: 'CS2 grafiti kutuları',
    stickersOne: '{{count}} çıkartma',
    stickersFew: '{{count}} çıkartma',
    stickersMany: '{{count}} çıkartma',
    musicKitsOne: '{{count}} müzik kiti',
    musicKitsFew: '{{count}} müzik kiti',
    musicKitsMany: '{{count}} müzik kiti',
    patchesOne: '{{count}} yama',
    patchesFew: '{{count}} yama',
    patchesMany: '{{count}} yama',
    pinsOne: '{{count}} rozet',
    pinsFew: '{{count}} rozet',
    pinsMany: '{{count}} rozet',
    graffitiOne: '{{count}} grafiti',
    graffitiFew: '{{count}} grafiti',
    graffitiMany: '{{count}} grafiti',
    colorsOne: '{{count}} renk',
    colorsFew: '{{count}} renk',
    colorsMany: '{{count}} renk',
    inGameSince: '{{year}} yılından beri oyunda',
    contentsTitle: 'İçinden çıkanlar',
    variantsTitle: 'Varyantlar',
    groupSticker: 'Çıkartma',
    groupSlab: 'Slab içinde',
    effectPaper: 'Kâğıt',
    effectHolo: 'Hologram',
    effectFoil: 'Folyo',
    effectGold: 'Altın',
    effectGlitter: 'Simli',
    effectLenticular: 'Lentiküler',
    effectEmbroidered: 'İşlemeli',
    stickerAutograph: 'İmzalı',
    stickerTeam: 'Takım',
    stickerEvent: 'Turnuva',
    stickerOther: 'Diğer',
    sideT: 'Teröristler',
    sideCt: 'Terörle Mücadele',
    statType: 'Tür',
    statStickerKind: 'Çıkartma türü',
    statTournament: 'Turnuva',
    statTeam: 'Takım',
    statPlayer: 'Oyuncu',
    statEffects: 'Efektler',
    statSlab: 'Slab içinde',
    statSide: 'Taraf',
    statArtist: 'Sanatçı',
    statStatTrak: 'StatTrak™',
    statColors: 'Renkler',
    valueYes: 'Var',
    valueNo: 'Yok',
    whereTitle: 'Nereden çıkar',
    whereCollection: 'Koleksiyon',
    whereStickerPack: 'Çıkartma paketi',
    shotHintItem: 'Bu eşya şu SHOT kasalarından çıkar.',
    souvenirPackagesRow: 'Hatıra paketleri',
    moreCount: '{{count}} tane daha',
    typeHighlight: 'Önemli an anahtarlığı',
    typePass: 'Bilet',
    typeKey: 'Anahtar',
    sectionHighlights: 'Önemli an anahtarlıkları',
    sectionPasses: 'Biletler',
    sectionKeys: 'Anahtarlar',
    kindOther: 'Paket',
    tabOther: 'Diğer',
    h1Other: 'CS2 diğer paketler',
    itemsOne: '{{count}} eşya',
    itemsFew: '{{count}} eşya',
    itemsMany: '{{count}} eşya',
    statEvent: 'Turnuva',
    statStage: 'Aşama',
    statMap: 'Harita',
    statTeams: 'Maç',
    statVideo: 'Video',
    watchVideo: 'Anı izle',
    statOpens: 'Açtığı kasalar',
    listH1Stickers: 'CS2 çıkartmaları',
    listH1Agents: 'CS2 ajanları',
    listH1Charms: 'CS2 anahtarlıkları',
    listH1MusicKits: 'CS2 müzik kitleri',
    listH1Patches: 'CS2 yamaları',
    listH1Graffiti: 'CS2 grafitileri',
    listH1Highlights: 'CS2 önemli an anahtarlıkları',
    listH1Pins: 'CS2 rozetleri',
    listH1Passes: 'CS2 biletleri',
    listH1Keys: 'CS2 kasa anahtarları',
    listCount: 'Oyunda: {{count}}',
    typeCollectible: 'Koleksiyon eşyası',
    sectionCollectibles: 'Hatıra paraları, madalyalar ve kupalar',
    listH1Collectibles: 'CS2 hatıra paraları, madalyaları ve kupaları',
    collectibleCoin: 'Hatıra parası',
    collectibleTrophy: 'Kupa',
    collectibleMedal: 'Madalya',
    versionNumber: '{{n}}. sürüm',
    allItemsTitle: 'Tüm eşyalar',
    sectionContainers: 'Kasalar ve kapsüller',
  },
});
